const config = window.AbdelmegedTheme || {};
const buttons = document.querySelectorAll('[data-reaction-button]');
const endpoint = `${config.restUrl || '/wp-json/abdelmeged/v1'}/reactions`;
const store = window.AbdelmegedLikeStore;
const formatter = new Intl.NumberFormat(document.documentElement.lang || config.language || 'ar');

const reducedMotion = () => document.documentElement.dataset.reducedMotion === 'true';

const countFor = (button) => {
  const count = button.querySelector('[data-reaction-count]');
  const raw = count?.textContent?.replace(/[^\d٠-٩۰-۹]/g, '') || '0';
  const normalized = raw
    .replace(/[٠-٩]/g, (digit) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)))
    .replace(/[۰-۹]/g, (digit) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)));

  return Number.parseInt(normalized, 10) || 0;
};

const setCount = (button, value) => {
  const count = button.querySelector('[data-reaction-count]');

  if (count) {
    count.textContent = formatter.format(Math.max(0, value));
  }
};

const setActive = (button, active) => {
  button.classList.toggle('is-active', active);
  button.setAttribute('aria-pressed', String(active));
};

const syncMatchingCounts = (contentId, counts) => {
  document.querySelectorAll(`[data-reaction-button][data-content-id="${contentId}"]`).forEach((button) => {
    const type = button.dataset.reactionType;

    if (Object.prototype.hasOwnProperty.call(counts, type)) {
      setCount(button, counts[type]);
    }
  });
};

const burst = (button) => {
  if (reducedMotion()) {
    return;
  }

  const element = document.createElement('span');
  element.className = 'abdelmeged-reaction-button__burst';
  element.setAttribute('aria-hidden', 'true');
  button.append(element);
  element.addEventListener('animationend', () => element.remove(), { once: true });
};

const requestReaction = async ({ contentId, type, delta }) => {
  const response = await fetch(endpoint, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      content_id: Number(contentId),
      type,
      delta,
    }),
  });

  if (!response.ok) {
    throw new Error('Reaction request failed.');
  }

  return response.json();
};

const onClick = async (button) => {
  if (!store || button.classList.contains('is-loading')) {
    return;
  }

  const contentId = button.dataset.contentId;
  const type = button.dataset.reactionType;
  const wasActive = store.has(contentId, type);
  const nextActive = !wasActive;
  const delta = nextActive ? 1 : -1;
  const previousCount = countFor(button);

  button.classList.remove('is-error');
  button.classList.add('is-loading');
  setActive(button, nextActive);
  setCount(button, previousCount + delta);
  store.set(contentId, type, nextActive);
  burst(button);

  try {
    const payload = await requestReaction({ contentId, type, delta });
    const counts = payload?.data?.counts;

    if (counts && typeof counts === 'object') {
      syncMatchingCounts(contentId, counts);
    }

    window.dispatchEvent(new CustomEvent('abdelmeged:interaction', { detail: { type: 'reaction' } }));
  } catch {
    button.classList.add('is-error');
    setActive(button, wasActive);
    setCount(button, previousCount);
    store.set(contentId, type, wasActive);
  } finally {
    button.classList.remove('is-loading');
  }
};

if (config.features?.reactions !== false && store) {
  buttons.forEach((button) => {
    const active = store.has(button.dataset.contentId, button.dataset.reactionType);
    setActive(button, active);
    button.addEventListener('click', () => onClick(button));
  });
}
